import { Component, ReactNode } from 'react'

import { RendererErrorState } from './RendererErrorState.component'
import Stack from '@mui/material/Stack'
import { UploadedFilesSection } from './UploadedFilesSection.component'
import { logger } from 'utils/logging'

interface Props {
  children: ReactNode
  /** When provided, UploadedFilesSection is shown alongside the error fallback */
  assignmentId?: string
  /** Product kind for error reporting context */
  productKind?: string
}

interface State {
  hasError: boolean
}

/**
 * Error boundary for assignment detail renderers.
 * Catches render-time exceptions and shows a friendly fallback
 * instead of white-screening the entire drawer.
 */
export class RendererErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    logger.error('Renderer crashed', error, {
      context: {
        component: 'RendererErrorBoundary',
        metadata: {
          assignmentId: this.props.assignmentId,
          productKind: this.props.productKind
        }
      }
    })
  }

  render() {
    if (this.state.hasError) return (
      <Stack gap="0.8rem">
        <RendererErrorState />
        {!!this.props.assignmentId &&
          <UploadedFilesSection assignmentId={this.props.assignmentId} />
        }
      </Stack>
    )
    return this.props.children
  }
}
